import { dateNode } from "discourse/helpers/node";
import { iconNode } from "discourse/lib/icon-library";
import { avatarFor as avatar } from "discourse/widgets/post";
import rawHtml from "discourse/widgets/raw-html";
export default {
  avatar,
  dateNode,
  iconNode,
  rawHtml
};